// extracted by mini-css-extract-plugin
export default {"body":"AddEditDeviationModal_body__19Ysp"};